import { Typography } from '@mui/material/styles/createTypography';
import { useTheme } from '@mui/system';
import { Text } from '@visx/text';
import React, { useContext } from 'react';
import {
	IAnalyticsContext,
	IWidgetXYTickComponentProps
} from 'types/analytics';
import { ITheme } from 'types/theme';
import AnalyticsContext from '../analytics/AnalyticsContext';
import { tickLabelFormat } from '../analytics/utils';

const WidgetXTickComponent: React.FC<IWidgetXYTickComponentProps> = ({
	value
}) => {
	const theme = useTheme<ITheme>();
	const style = {
		...(theme.typography as Typography).subtitle2,
		fontWeight: 200,
		fill: theme.palette.text.secondary
	};
	const { timePeriod } = useContext<IAnalyticsContext>(AnalyticsContext);

	const formatted = tickLabelFormat(timePeriod)(value);
	const [first, second] = (formatted || '').split(' ');

	return (
		<g>
			<Text
				x={-10}
				y={0}
				style={style}
				width={16}
				scaleToFit="shrink-only"
				angle={30}
			>
				{first}
			</Text>
			{second && (
				<Text
					y={25}
					style={style}
					textAnchor="middle"
					width={16}
					scaleToFit="shrink-only"
				>
					{second}
				</Text>
			)}
		</g>
	);
};

export default WidgetXTickComponent;
